kingBeds_one: King Bed
kingBeds_other: '{{ count }} King Beds'
queenBeds_one: Queen Bed
queenBeds_other: '{{ count }} Queen Beds'
doubleBeds_one: Double Bed
doubleBeds_other: '{{ count }} Double Beds'
twinBeds_one: Twin Beds
twinBeds_other: '{{ count }} Twin Beds'
singleBeds_one: Single Bed
singleBeds_other: '{{ count }} Single Beds'
pullmanBeds_one: Pullman Bed
pullmanBeds_other: '{{ count }} Pullman Beds'
baths_one: Bath
baths_other: '{{ count }} Baths'
heads_one: Toilet
heads_other: '{{ count }} Toilets'
showers_one: Shower
showers_other: '{{ count }} Showers'